import { isGuestRoute } from "~/routes";

export default defineNuxtRouteMiddleware((to) => {
  if (isGuestRoute(to.path)) {
    setPageLayout("auth");
  }
});
